export default [
  {
    html: `<div class="ships">
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
    </div>
    <div class="aims">
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
    </div>`,
    study: 'https://w3c.hexschool.com/Flexbox%20%E6%98%AF%E7%94%9A%E9%BA%BC-2186a786',
    topic: 'FLEX 海盜集團的保衛船隻並排放在座標的左上角正在休息，是個偷襲的好機會，準心就和一般的 div 一樣，預設的屬性為 display: block',
    prompt: ['.aims'],
    displayData: '',
    notice: '<span style="font-size: 16px">將準心 (.aims) 的 display 設為 flex 可以輕鬆達到並排的目的。</span>',
    ans: {
      '.aims': {
        display: ['flex'],
      },
    },
  },
  {
    html: `<div class="ships">
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
    </div>
    <div class="aims">
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
    </div>`,
    study: 'https://w3c.hexschool.com/justify-content-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-4a029043',
    topic: '這層的守衛船隻並排停放在主軸線的最末端。',
    prompt: ['.aims'],
    displayData: {
      'justify-content': true,
      'align-items': false,
      'flex-wrap': false,
      'flex-direction': false,
      'align-content': false,
      order: false,
      flex: false,
    },
    notice: '',
    ans: {
      '.aims': {
        display: ['flex'],
        'justify-content': ['flex-end', 'start', 'right'],
      },
    },
  },
  {
    html: `<div class="ships">
      <div class="item big"></div>
    </div>
    <div class="aims">
      <div class="item power animated infinite pulse slower"></div>
    </div>`,
    study: 'https://w3c.hexschool.com/justify-content-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-4a029043',
    topic: '這層的守衛是條大型戰艦，在座標中上方，艦長決定使用攻擊力較強的大砲攻擊。',
    prompt: ['.aims'],
    displayData: {
      'justify-content': true,
      'align-items': false,
      'flex-wrap': false,
      'flex-direction': false,
      'align-content': false,
      order: false,
      flex: false,
    },
    notice: '',
    ans: {
      '.aims': {
        display: ['flex'],
        'justify-content': ['center', 'space-around', 'space-evenly'],
      },
    },
  },
  { // 3 (2-3)
    html: `<div class="ships">
      <div class="item sm"></div>
      <div class="item big"></div>
      <div class="item sm"></div>
    </div>
    <div class="aims">
      <div class="item normal animated infinite pulse"></div>
      <div class="item power animated infinite pulse slower"></div>
      <div class="item normal animated infinite pulse"></div>
    </div>`,
    study: 'https://w3c.hexschool.com/justify-content-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-4a029043',
    topic: '這層守衛有一條大型及兩條小戰艦，在入口前平均分配間距守著。',
    prompt: ['.aims'],
    displayData: {
      'justify-content': true,
      'align-items': false,
      'flex-wrap': false,
      'flex-direction': false,
      'align-content': false,
      order: false,
      flex: false,
    },
    notice: '',
    ans: {
      '.aims': {
        display: ['flex'],
        'justify-content': ['space-around'],
      },
    },
  },
  { // 4 (2-4)
    html: `<div class="ships">
      <div class="item sm"></div>
      <div class="item big"></div>
      <div class="item sm"></div>
    </div>
    <div class="aims">
      <div class="item normal animated infinite pulse"></div>
      <div class="item power animated infinite pulse slower"></div>
      <div class="item normal animated infinite pulse"></div>
    </div>`,
    study: 'https://w3c.hexschool.com/justify-content-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-4a029043',
    topic: '這層入口只有一艘小戰艦守著，但主軸線最前端和最末端都有大型戰艦護著 ',
    prompt: ['.aims'],
    displayData: {
      'justify-content': true,
      'align-items': false,
      'flex-wrap': false,
      'flex-direction': false,
      'align-content': false,
      order: false,
      flex: false,
    },
    notice: '',
    ans: {
      '.aims': {
        display: ['flex'],
        'justify-content': ['space-between'],
      },
    },
  },
  { // 5 (3-1)
    html: `<div class="ships">
    <div class="item sm"></div>
    <div class="item sm"></div>
    <div class="item sm"></div>
  </div>
  <div class="aims">
    <div class="item normal animated infinite pulse"></div>
    <div class="item normal animated infinite pulse"></div>
    <div class="item normal animated infinite pulse"></div>
  </div>`,
    study: 'https://w3c.hexschool.com/align-items-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-87d66dc4',
    topic: '這層的小戰艦並排停放在副軸線的最末端入口處，裡面空無一人，艦長還是決定炸了以除後患。',
    prompt: ['.aims'],
    displayData: {
      'justify-content': false,
      'align-items': true,
      'flex-wrap': false,
      'flex-direction': false,
      'align-content': false,
      order: false,
      flex: false,
    },
    notice: '',
    ans: {
      '.aims': {
        display: ['flex'],
        'align-items': ['flex-end'],
      },
    },
  },
  { // 6 (3-2)
    html: `<div class="ships">
      <div class="item big"></div>
    </div>
    <div class="aims">
      <div class="item power animated infinite pulse slower"></div>
    </div>`,
    study: 'https://w3c.hexschool.com/align-items-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-87d66dc4',
    topic: '副軸中央有艘大型戰艦，原來海盜都跑去裡面開 party 了',
    prompt: ['.aims'],
    displayData: {
      'justify-content': false,
      'align-items': true,
      'flex-wrap': false,
      'flex-direction': false,
      'align-content': false,
      order: false,
      flex: false,
    },
    notice: '',
    ans: {
      '.aims': {
        display: ['flex'],
        'align-items': ['center'],
      },
    },
  },
  { // 7 (3-3)
    html: `<div class="ships">
    </div>
    <div class="aims">
      <div class="item hex"></div>
    </div>`,
    study: 'https://w3c.hexschool.com/align-items-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-87d66dc4',
    topic: '這層完全沒有守衛，開了這麼久的船，船員也都累了，艦長決定將六角戰艦停放在主軸與副軸線正中央，在這層休息一下。',
    prompt: ['.aims'],
    displayData: {
      'justify-content': true,
      'align-items': true,
      'flex-wrap': false,
      'flex-direction': false,
      'align-content': false,
      order: false,
      flex: false,
    },
    notice: '',
    ans: {
      '.aims': {
        display: ['flex'],
        'align-items': ['center'],
        'justify-content': ['center', 'space-around', 'space-evenly'],
      },
    },
  },
  { // 8 (3-4)
    html: `<div class="ships">
      <div class="item big"></div>
      <div class="item big"></div>
    </div>
    <div class="aims">
      <div class="item power animated infinite pulse slower"></div>
      <div class="item power animated infinite pulse slower"></div>
    </div>`,
    study: 'https://w3c.hexschool.com/align-items-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-87d66dc4',
    topic: '這層有兩條大型戰艦停放在副軸線最底端，並且分別分配在主軸線的最前端和最末端',
    prompt: ['.aims'],
    displayData: {
      'justify-content': true,
      'align-items': true,
      'flex-wrap': false,
      'flex-direction': false,
      'align-content': false,
      order: false,
      flex: false,
    },
    notice: '',
    ans: {
      '.aims': {
        display: ['flex'],
        'justify-content': ['space-between'],
        'align-items': ['flex-end'],
      },
    },
  },
  { // 9 (4-1)
    html: `<div class="ships">
      <div class="item big"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
    </div>
    <div class="aims">
      <div class="item power animated infinite pulse slower"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
    </div>`,
    study: 'https://w3c.hexschool.com/flex-wrap-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-4ed6ec22',
    topic: '這層第一排有 1 條大型戰艦和 5 條小戰艦，下方有 1 條落單的小戰艦。',
    prompt: ['.aims'],
    displayData: {
      'justify-content': false,
      'align-items': false,
      'flex-wrap': true,
      'flex-direction': false,
      'align-content': false,
      order: false,
      flex: false,
    },
    notice: '',
    ans: {
      '.aims': {
        display: ['flex'],
        'flex-wrap': ['wrap'],
      },
    },
  },
  { // 10 (4-2)
    html: `<div class="ships">
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item big"></div>
    </div>
    <div class="aims">
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item power animated infinite pulse slower"></div>
    </div>`,
    study: 'https://w3c.hexschool.com/flex-wrap-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-4ed6ec22',
    topic: '這層副軸線最末端有 6 條小戰艦，上方有一條大型戰艦護著。將準心設成多行且副軸線反轉即可瞄準相對應的海盜戰艦。',
    prompt: ['.aims'],
    displayData: {
      'justify-content': false,
      'align-items': false,
      'flex-wrap': true,
      'flex-direction': false,
      'align-content': false,
      order: false,
      flex: false,
    },
    notice: '',
    ans: {
      '.aims': {
        display: ['flex'],
        'flex-wrap': ['wrap-reverse'],
      },
    },
  },
  { // 11 (5-1)
    html: `<div class="ships">
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item big"></div>
    </div>
    <div class="aims">
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item power animated infinite pulse slower"></div>
    </div>`,
    study: 'https://w3c.hexschool.com/align-content-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-d0e569ef',
    topic: '這層第一排有6條小戰艦、下方有1條大型戰艦，看起來是海盜們正在分配人數要移動到大型戰艦工作',
    prompt: ['.aims'],
    displayData: {
      'justify-content': false,
      'align-items': false,
      'flex-wrap': true,
      'flex-direction': false,
      'align-content': true,
      order: false,
      flex: false,
    },
    notice: '',
    ans: {
      '.aims': {
        display: ['flex'],
        'flex-wrap': ['wrap'],
        'align-content': ['flex-start', 'baseline', 'start', 'end'],
      },
    },
  },
  { // 12 (5-2)
    html: `<div class="ships">
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item big"></div>
      <div class="item sm"></div>
    </div>
    <div class="aims">
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item power animated infinite pulse slower"></div>
      <div class="item normal animated infinite pulse"></div>
    </div>`,
    study: 'https://w3c.hexschool.com/align-content-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-d0e569ef',
    topic: '副軸線最前端有6條小戰艦、最後端有2條小戰艦和1條大型戰艦，呈水平置中排列。這麼多艘船守著，看來是對方提高警覺心了!',
    prompt: ['.aims'],
    displayData: {
      'justify-content': true,
      'align-items': false,
      'flex-wrap': true,
      'flex-direction': false,
      'align-content': true,
      order: false,
      flex: false,
    },
    notice: '',
    ans: {
      '.aims': {
        display: ['flex'],
        'flex-wrap': ['wrap'],
        'align-content': ['space-between'],
        'justify-content': ['center'],
      },
    },
  },
  { // 13 (6-1)
    html: `<div class="ships">
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item big"></div>
    </div>
    <div class="aims">
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item power animated infinite pulse slower"></div>
    </div>`,
    study: 'https://w3c.hexschool.com/flex-direction-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-c1b62b9b',
    topic: '這層有3條小戰艦和1條大型戰艦，直向排列在座標圖上的中間。請將準心排列方向改為直向。',
    prompt: ['.aims'],
    displayData: {
      'justify-content': false,
      'align-items': true,
      'flex-wrap': false,
      'flex-direction': true,
      'align-content': false,
      order: false,
      flex: false,
    },
    notice: `
    <span class="text-danger">提示: 更改為直向排列後，主軸線與交錯軸位置會調換</span>
    `,
    ans: {
      '.aims': {
        display: ['flex'],
        'flex-direction': ['column'],
        'align-items': ['center'],
      },
    },
  },
  { // 14 (6-2)
    html: `<div class="ships">
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
    </div>
    <div class="aims">
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
    </div>`,
    study: 'https://w3c.hexschool.com/flex-direction-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-c1b62b9b',
    topic: '這一層有4條小戰艦，垂直置中並直向排列在座標圖中。',
    prompt: ['.aims'],
    displayData: {
      'justify-content': true,
      'align-items': false,
      'flex-wrap': false,
      'flex-direction': true,
      'align-content': false,
      order: false,
      flex: false,
    },
    notice: `
    試著結合 justify-content、align-content 或 align-items 來應用
    `,
    ans: {
      '.aims': {
        display: ['flex'],
        'flex-direction': ['column', 'column-reverse'],
        'justify-content': ['center'],
      },
    },
  },
  { // 15 (6-3)
    html: `<div class="ships">
      <div class="item sm"></div>
      <div class="item big"></div>
      <div class="item sm"></div>
    </div>
    <div class="aims">
      <div class="item normal animated infinite pulse"></div>
      <div class="item power animated infinite pulse slower"></div>
      <div class="item normal animated infinite pulse"></div>
    </div>`,
    study: 'https://w3c.hexschool.com/flex-direction-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-c1b62b9b',
    topic: '這層有兩條小戰艦，中間有一條大型戰艦呈直向排列，水平置中且垂直均分於座標圖中。',
    prompt: ['.aims'],
    displayData: {
      'justify-content': true,
      'align-items': true,
      'flex-wrap': false,
      'flex-direction': true,
      'align-content': false,
      order: false,
      flex: false,
    },
    notice: `
    `,
    ans: {
      '.aims': {
        display: ['flex'],
        'flex-direction': ['column', 'column-reverse'],
        'align-items': ['center'],
        'justify-content': ['space-around'],
      },
    },
  },
  { // 16 (6-4)
    html: `<div class="ships">
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item big"></div>
      <div class="item big"></div>
      <div class="item big"></div>
    </div>
    <div class="aims">
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item power animated infinite pulse slower"></div>
      <div class="item power animated infinite pulse slower"></div>
      <div class="item power animated infinite pulse slower"></div>
    </div>`,
    study: 'https://w3c.hexschool.com/flex-direction-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-c1b62b9b',
    topic: '座標圖上最左邊有一排小型戰艦直向排列，中間也有三條大型戰艦直向排列。',
    prompt: ['.aims'],
    displayData: {
      'justify-content': true,
      'align-items': false,
      'flex-wrap': true,
      'flex-direction': true,
      'align-content': false,
      order: false,
      flex: false,
    },
    notice: `
    `,
    ans: {
      '.aims': {
        display: ['flex'],
        'flex-wrap': ['wrap'],
        'flex-direction': ['column', 'column-reverse'],
        'justify-content': ['center'],
      },
    },
  },
  { // 17 (6-5)
    html: `<div class="ships">
      <div class="item big"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item big"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item big"></div>
      <div class="item big"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
    </div>
    <div class="aims">
      <div class="item power animated infinite pulse slower"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item power animated infinite pulse slower"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item power animated infinite pulse slower"></div>
      <div class="item power animated infinite pulse slower"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
    </div>`,
    study: 'https://w3c.hexschool.com/flex-direction-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-c1b62b9b',
    topic: '座標圖上有兩排垂直排列的船隻分別貼齊座標圖主軸線最左邊和最右邊，但擺設順序和準心排列順序相反。',
    prompt: ['.aims'],
    displayData: {
      'justify-content': false,
      'align-items': false,
      'flex-wrap': true,
      'flex-direction': true,
      'align-content': true,
      order: false,
      flex: false,
    },
    notice: `
    `,
    ans: {
      '.aims': {
        display: ['flex'],
        'flex-direction': ['column', 'column-reverse'],
        'flex-wrap': ['wrap-reverse'],
        'align-content': ['space-between'],
      },
    },
  },
  { // 18 (6-6)
    html: `<div class="ships">
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item big"></div>
    </div>
    <div class="aims">
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item power animated infinite pulse slower"></div>
    </div>`,
    study: 'https://w3c.hexschool.com/flex-direction-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-c1b62b9b',
    topic: '這層小戰艦垂直排列在座標圖最右邊，有條大型戰艦垂直置中在隊伍前。設定為多行且直向排列後，在設定每行貼齊最前方且垂直置中，會發現準線方向與船隻相反，將"多行"設定成"多行且反轉"即可。',
    prompt: ['.aims'],
    displayData: {
      'justify-content': true,
      'align-items': false,
      'flex-wrap': true,
      'flex-direction': true,
      'align-content': true,
      order: false,
      flex: false,
    },
    notice: `
    `,
    ans: {
      '.aims': {
        display: ['flex'],
        'flex-direction': ['column', 'column-reverse'],
        'align-content': ['flex-start', 'start'],
        'flex-wrap': ['wrap-reverse'],
        'justify-content': ['center'],
      },
    },
  },
  { // 19 (6-7)
    html: `<div class="ships">
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item big"></div>
    </div>
    <div class="aims">
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item power animated infinite pulse slower"></div>
    </div>`,
    study: 'https://w3c.hexschool.com/flex-direction-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-c1b62b9b',
    topic: '這層有三條小戰艦和一條大戰艦，但船隻排放順序和準心排放順序相反，水平垂直置中橫向排列在座標圖上。',
    prompt: ['.aims'],
    displayData: {
      'justify-content': true,
      'align-items': true,
      'flex-wrap': false,
      'flex-direction': true,
      'align-content': false,
      order: false,
      flex: false,
    },
    notice: `
    `,
    ans: {
      '.aims': {
        display: ['flex'],
        'flex-direction': ['row-reverse'],
        'justify-content': ['center'],
        'align-items': ['center'],
      },
    },
  },
  { // 20 (7-1)
    html: `<div class="ships">
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item big"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
    </div>
    <div class="aims">
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item power animated infinite pulse slower"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
    </div>`,
    study: 'https://w3c.hexschool.com/order-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-4007bc24',
    topic: '座標圖上 (.aims) 水平置中處有五條戰艦橫向並排在座標上，大型戰艦在隊伍的最後面，和我們準心擺設順序不同，請將大砲準心 (.power) 順序改為 1 移至最後方。',
    prompt: ['.aims', '.power'],
    displayData: {
      'justify-content': true,
      'align-items': true,
      'flex-wrap': false,
      'flex-direction': false,
      'align-content': false,
      order: true,
      flex: false,
    },
    notice: `
    <span class="text-danger">註: 這裡 order 只接受 1 或 -1 </span>
    `,
    ans: {
      '.aims': {
        display: ['flex'],
        'justify-content': ['center'],
        'align-items': ['center'],
      },
      '.power': {
        order: ['1'],
      },
    },
  },
  { // 21 (7-2)
    html: `<div class="ships">
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item big"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
      <div class="item big"></div>
      <div class="item sm"></div>
      <div class="item sm"></div>
    </div>
    <div class="aims">
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item power animated infinite pulse slower"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item power animated infinite pulse slower"></div>
      <div class="item normal animated infinite pulse"></div>
      <div class="item normal animated infinite pulse"></div>
    </div>`,
    study: 'https://w3c.hexschool.com/order-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-4007bc24',
    topic: '這層的戰艦呈直向兩行排列，後方兩條大型戰艦位於副軸線中央，和我們準心擺設順序不同，請將大砲準心 (.power) 改至最後方。',
    prompt: ['.aims', '.power'],
    displayData: {
      'justify-content': true,
      'align-items': false,
      'flex-wrap': true,
      'flex-direction': true,
      'align-content': false,
      order: true,
      flex: false,
    },
    notice: `
    <span class="text-danger">註: 這裡 order 只接受 1 或 -1 </span>
    `,
    ans: {
      '.aims': {
        display: ['flex'],
        'flex-wrap': ['wrap'],
        'justify-content': ['center'],
        'flex-direction': ['column', 'column-reverse'],
      },
      '.power': {
        order: ['1'],
      },
    },
  },
  { // 22 (8-1)
    html: `<div class="ships">
      <div class="island">
        <div class="item hex"></div>
      </div>
    </div>
    <div class="aims">
      <div class="camp">
        <div class="area-sleep">
          睡覺空間
        </div>
        <div class="area-work">
          工作空間
        </div>
      </div>
    </div>`,
    study: 'https://w3c.hexschool.com/flex-basis%E3%80%81flex-grow%E3%80%81flex-shrink-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-9883b0fb',
    topic: '六角戰艦找到了一座孤島想進駐一陣子，灰色框線內的空間為可使用範圍，請透過以下步驟分配使用空間:',
    prompt: ['.area-sleep', '.area-work'],
    displayData: {
      'justify-content': false,
      'align-items': false,
      'flex-wrap': false,
      'flex-direction': false,
      'align-content': false,
      order: false,
      flex: true,
    },
    notice: `
    <ul style="list-style-type: disc;padding-left: 20px; color: #333;">
      <li>睡覺空間 (.area-sleep) 與工作空間 (.area-work) 的基本大小為 120px，請使用 <span class="text-danger">flex-basis</span>  來配置。</li>
      <li>
        剩餘空間請以 <span class="text-danger">flex-grow</span>，以 2:1 的比例，分別分配
        <span class="text-danger">2</span> 和 <span class="text-danger">1</span> 
        給睡覺空間與工作空間
      </li>
    </ul>
    `,
    ans: {
      '.area-sleep': {
        'flex-basis': ['120px'],
        'flex-grow': ['2'],
      },
      '.area-work': {
        'flex-basis': ['120px'],
        'flex-grow': ['1'],
      },
    },
  },
  { // 23 (8-2)
    html: `<div class="ships">
      <div class="island">
        <div class="item hex"></div>
      </div>
    </div>
    <div class="aims">
      <div class="camp">
        <div class="area-sleep">
          睡覺空間
        </div>
        <div class="area-work">
          工作空間
        </div>
      </div>
    </div>`,
    study: 'https://w3c.hexschool.com/flex-basis%E3%80%81flex-grow%E3%80%81flex-shrink-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-9883b0fb',
    topic: '隔天發現這座小島部分空間土質容易塌陷，不適合住人，因此灰色框線可使用空間縮小了，空間需要重新配置。',
    prompt: ['.area-sleep', '.area-work'],
    displayData: {
      'justify-content': false,
      'align-items': false,
      'flex-wrap': false,
      'flex-direction': false,
      'align-content': false,
      order: false,
      flex: true,
    },
    notice: `
    <ul style="list-style-type: disc;padding-left: 20px; color: #333;">
      <li>睡覺空間 (.area-sleep) 與工作空間 (.area-work) 的基本大小為 120px，請使用 <span class="text-danger">flex-basis</span> 來配置。</li>
      <li>如果可使用空間不夠使用，睡眠空間也不能小於基本大小，請使用 <span class="text-danger">flex-shrink</span> 取消縮小睡眠空間</li>
    </ul>
    `,
    ans: {
      '.area-sleep': {
        'flex-basis': ['120px'],
        'flex-shrink': ['0'],
      },
      '.area-work': {
        'flex-basis': ['120px'],
      },
    },
  },
  { // 24 (8-3)
    html: `<div class="ships">
      <div class="island">
        <div class="item hex"></div>
      </div>
    </div>
    <div class="aims">
      <div class="camp">
        <div class="area-sleep">睡覺空間</div>
        <div class="area-work">工作空間</div>
      </div>
    </div>`,
    study: 'https://w3c.hexschool.com/flex-basis%E3%80%81flex-grow%E3%80%81flex-shrink-%E5%B1%AC%E6%80%A7%E4%BB%8B%E7%B4%B9-9883b0fb',
    topic: ' 六角戰艦換了一座小島進駐，灰色框線內的空間為可使用範圍，請透過下列步驟分配使用空間',
    prompt: ['.camp', '.area-sleep', '.area-work'],
    displayData: {
      'justify-content': false,
      'align-items': false,
      'flex-wrap': false,
      'flex-direction': true,
      'align-content': false,
      order: false,
      flex: true,
    },
    notice: `
    <ul style="list-style-type: disc;padding-left: 20px; color: #333;">
      <li>將灰色空間 .camp 的 flex-direction 改為直向排列</li>
      <li>睡覺空間 (.area-sleep) 與工作空間 (.area-work) 的基本大小為 120px，請使用 <span class="text-danger">flex-basis</span> 來配置。</li>
      <li>剩餘空間請以  <span class="text-danger">flex-grow</span>，以 3:2 的比例，分別分配
      <span class="text-danger">3</span> 和 <span class="text-danger">2</span> 
      給睡覺空間與工作空間</li>
    </ul>
    `,
    ans: {
      '.camp': {
        display: ['flex'],
        'flex-direction': ['column', 'column-reverse'],
      },
      '.area-sleep': {
        'flex-basis': ['120px'],
        'flex-grow': ['3'],
      },
      '.area-work': {
        'flex-basis': ['120px'],
        'flex-grow': ['2'],
      },
    },
  },
  { // 25 (9-1)
    html: `<div class="ships">
      <div class="area-left">
        <div class="item big"></div>
        <div class="item big"></div>
        <div class="item big"></div>
      </div>
      <div class="area-right">
        <div class="item sm"></div>
        <div class="item sm"></div>
        <div class="item sm"></div>
      </div>
    </div>
    <div class="aims">
      <div class="aims-light">
        <div class="item power animated infinite pulse slower"></div>
        <div class="item power animated infinite pulse slower"></div>
        <div class="item power animated infinite pulse slower"></div>
      </div>
      <div class="aims-dark">
        <div class="item normal animated infinite pulse"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item normal animated infinite pulse"></div>
      </div>
    </div>`,
    study: 'https://w3c.hexschool.com/tag/flex-pirate-info',
    topic: `
    這層有兩個海域，分別是淺色海域和深色海域，船長以準心顏色分了兩區塊，
    深色準心區塊 (.aims-dark) 與淺色準心區塊 (.aims-light) 。請依照下列步驟調整準心位置
    `,
    prompt: ['.aims', '.aims-light', '.aims-dark'],
    displayData: {
      'justify-content': true,
      'align-items': true,
      'flex-wrap': false,
      'flex-direction': true,
      'align-content': false,
      order: false,
      flex: false,
    },
    notice: `
    <ul style="list-style-type: disc;padding-left: 20px; color: #333;">
      <li>先將兩個準心區塊 .aims-light, .aims-dark 設有 flex 效果</li>
      <li>透過 flex-direction 將淺色準心區塊 (.aims-light) 改為直向排列，再將內容物設為垂直置中。</li>
      <li>將深色準心區塊 (.aims-dark) 內容物垂直置中。</li>
    </ul>
    `,
    ans: {
      '.aims': {
        display: ['flex'],
      },
      '.aims-light': {
        display: ['flex'],
        'flex-direction': ['column', 'column-reverse'],
        'justify-content': ['center'],
      },
      '.aims-dark': {
        display: ['flex'],
        'align-items': ['center'],
      },
    },
  },
  { // 26 (9-2)
    html: `<div class="ships">
      <div class="area-1">
        <div class="item big"></div>
        <div class="item big"></div>
        <div class="item big"></div>
      </div>
      <div class="area-2">
        <div class="item sm"></div>
        <div class="item sm"></div>
        <div class="item sm"></div>
        <div class="item big"></div>
        <div class="item sm"></div>
        <div class="item sm"></div>
        <div class="item big"></div>
      </div>
    </div>
    <div class="aims">
      <div class="aims-light">
        <div class="item power animated infinite pulse slower"></div>
        <div class="item power animated infinite pulse slower"></div>
        <div class="item power animated infinite pulse slower"></div>
      </div>
      <div class="aims-dark">
        <div class="item normal animated infinite pulse"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item power animated infinite pulse slower"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item power animated infinite pulse slower"></div>
      </div>
    </div>`,
    study: 'https://w3c.hexschool.com/tag/flex-pirate-info',
    topic: `
    這層有兩個海域，淺色海域基本大小為 150px，配置空間不會小於基本大小。
    深色海域每行的排列順序和六角戰艦的準心順序相反。請依照下列步驟調整準心位置`,
    prompt: ['.aims', '.aims-light', '.aims-dark'],
    displayData: {
      'justify-content': true,
      'align-items': true,
      'flex-wrap': true,
      'flex-direction': true,
      'align-content': true,
      order: false,
      flex: true,
    },
    notice: `
    <ul style="list-style-type: disc;padding-left: 20px; color: #333;">
      <li>先將兩個準心區塊 .aims-light, .aims-dark 設有 flex 效果</li>
      <li>透過 flex-direction 將 .aims-light 改為直向排列，再將內容物設為水平置中</li>
      <li>使用 <span class="text-danger">flex-basis</span> 設定 .aims-light 的基本大小後，調整 <span class="text-danger">flex-shrink</span> 數值，讓它配置的空間不會小於基本大小</li>
      <li>使用 flex-wrap 將 .aims-dark 設為多行後，透過 align-content 讓元素對齊最上方。</li>
      <li>將 .aims-dark 內元素設為水平置中</li>
      <li>透過 flex-direction 將 .aims-dark 每行排列順序顛倒</li>
    </ul>
    `,
    ans: {
      '.aims': {
        display: ['flex'],
      },
      '.aims-light': {
        display: ['flex'],
        'flex-direction': ['column', 'column-reverse'],
        'align-items': ['center'],
        'flex-basis': ['150px'],
        'flex-shrink': ['0'],
      },
      '.aims-dark': {
        display: ['flex'],
        'flex-direction': ['row-reverse'],
        'justify-content': ['center'],
        'flex-wrap': ['wrap'],
        'align-content': ['flex-start', 'start'],
      },
    },
  },
  { // 27 (9-3)
    html: `<div class="ships">
      <div class="area-1">
        <div class="item big"></div>
        <div class="item sm"></div>
      </div>
      <div class="area-2">
        <div class="item sm"></div>
        <div class="item sm"></div>
        <div class="item sm"></div>
        <div class="item big"></div>
        <div class="item sm"></div>
        <div class="item sm"></div>
        <div class="item sm"></div>
        <div class="item big"></div>
        <div class="item sm"></div>
        <div class="item sm"></div>
      </div>
    </div>
    <div class="aims">
      <div class="aims-light">
        <div class="item power animated infinite pulse slower"></div>
        <div class="item normal animated infinite pulse"></div>
      </div>
      <div class="aims-dark">
        <div class="item normal animated infinite pulse"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item power animated infinite pulse slower"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item power animated infinite pulse slower"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item normal animated infinite pulse"></div>
      </div>
    </div>`,
    study: 'https://w3c.hexschool.com/tag/flex-pirate-info',
    topic: `
    這層有兩個海域，淺色海域基本大小為 150px，配置空間不會小於基本大小。
    深色海域每行的排列順序和六角戰艦的準心順序相反。請依照下列步驟調整準心位置`,
    prompt: ['.aims', '.aims-light', '.aims-dark', '.aims-dark .power'],
    displayData: {
      'justify-content': true,
      'align-items': false,
      'flex-wrap': true,
      'flex-direction': true,
      'align-content': false,
      order: true,
      flex: false,
    },
    notice: `
    <ul style="list-style-type: disc;padding-left: 20px; color: #333;">
      <li>將 .aims 改為直向排列</li>
      <li>將 .aims-light 設為靠邊均分對齊</li>
      <li>設定 .aims-dark 為多行排列</li>
      <li>將 .aims-dark 裡的大砲位置擺放置順序最前面，寫在 .aims-dark .power 選擇器內</li>
    </ul>
    <span class="text-danger">註: 這裡 order 只接受 1 或 -1 </span>
    `,
    ans: {
      '.aims': {
        display: ['flex'],
        'flex-direction': ['column'],
      },
      '.aims-light': {
        display: ['flex'],
        'justify-content': ['space-between'],
      },
      '.aims-dark': {
        display: ['flex'],
        'flex-wrap': ['wrap'],
      },
      '.aims-dark .power': {
        order: ['-1'],
      },
    },
  },
  { // 28 (9-4)
    html: `<div class="ships">
      <div class="area-1">
        <div class="item big"></div>
        <div class="item sm"></div>
        <div class="item big"></div>
        <div class="item sm"></div>
      </div>
      <div class="area-2">
        <div class="item big"></div>
        <div class="item sm"></div>
        <div class="item sm"></div>
        <div class="item big"></div>
        <div class="item sm"></div>
        <div class="item sm"></div>
        <div class="item sm"></div>
        <div class="item big"></div>
        <div class="item sm"></div>
        <div class="item sm"></div>
        <div class="item sm"></div>
        <div class="item big"></div>
        <div class="item sm"></div>
        <div class="item sm"></div>
        <div class="item big"></div>
      </div>
    </div>
    <div class="aims">
      <div class="aims-light">
        <div class="item power animated infinite pulse slower"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item power animated infinite pulse slower"></div>
        <div class="item normal animated infinite pulse"></div>
      </div>
      <div class="aims-dark">
        <div class="item power animated infinite pulse slower"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item power animated infinite pulse slower"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item power animated infinite pulse slower"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item power animated infinite pulse slower"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item power animated infinite pulse slower"></div>
      </div>
    </div>`,
    study: 'https://w3c.hexschool.com/tag/flex-pirate-info',
    topic: `這層有兩個海域，深色海域最後五條都是大型戰艦，和我們準心排列順序不同。
    請依照下列步驟調整準心位置`,
    prompt: ['.aims', '.aims-light', '.aims-dark', '.aims-dark .power'],
    displayData: {
      'justify-content': true,
      'align-items': false,
      'flex-wrap': true,
      'flex-direction': true,
      'align-content': true,
      order: true,
      flex: false,
    },
    notice: `
    <ul style="list-style-type: disc;padding-left: 20px; color: #333;">
      <li>將 .aims-light 改為直向排列，並設為靠邊均分對齊</li>
      <li>設定 .aims-dark 為多行排列，並加入 space-around 效果將剩餘空間均分排列</li>
      <li>將 .aims-dark 裡的大砲位置擺放置順序最後面，寫在.aims-dark .power 選擇器內</li>
    </ul>
    <span class="text-danger">註: 這裡 order 只接受 1 或 -1 </span>
    `,
    ans: {
      '.aims': {
        display: ['flex'],
      },
      '.aims-light': {
        display: ['flex'],
        'flex-direction': ['column'],
        'justify-content': ['space-between'],
      },
      '.aims-dark': {
        display: ['flex'],
        'flex-wrap': ['wrap'],
        'align-content': ['space-around'],
      },
      '.aims-dark .power': {
        order: ['1'],
      },
    },
  },
  { // 29 (9-5)
    html: `<div class="ships">
      <div class="area-1">
        <div class="item big"></div>
        <div class="item sm"></div>
        <div class="item big"></div>
        <div class="item sm"></div>
      </div>
      <div class="area-2">
        <div class="item big"></div>
        <div class="item sm"></div>
        <div class="item sm"></div>
        <div class="item big"></div>
        <div class="item sm"></div>
        <div class="item sm"></div>
        <div class="item sm"></div>
        <div class="item big"></div>
        <div class="item sm"></div>
        <div class="item sm"></div>
        <div class="item sm"></div>
        <div class="item big"></div>
        <div class="item sm"></div>
        <div class="item sm"></div>
        <div class="item big"></div>
      </div>
    </div>
    <div class="aims">
      <div class="aims-light">
        <div class="item power animated infinite pulse slower"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item power animated infinite pulse slower"></div>
        <div class="item normal animated infinite pulse"></div>
      </div>
      <div class="aims-dark">
        <div class="item power animated infinite pulse slower"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item power animated infinite pulse slower"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item power animated infinite pulse slower"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item power animated infinite pulse slower"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item normal animated infinite pulse"></div>
        <div class="item power animated infinite pulse slower"></div>
      </div>
    </div>`,
    study: 'https://w3c.hexschool.com/tag/flex-pirate-info',
    topic: `這層有兩個海域分別貼齊在座標圖的上邊和下邊。
    請依照下列步驟調整準心位置`,
    prompt: ['.aims', '.aims-light', '.aims-dark'],
    displayData: {
      'justify-content': true,
      'align-items': false,
      'flex-wrap': true,
      'flex-direction': true,
      'align-content': false,
      order: false,
      flex: false,
    },
    notice: `
    <ul style="list-style-type: disc;padding-left: 20px; color: #333;">
      <li>將 .aims 設為垂直且反向排列，並設定內容物靠邊對齊。</li>
      <li>將 .aims-light 設為靠邊均分對齊</li>
      <li>將 .aims-dark 設為多行，且反向排列</li>
    </ul>
    `,
    ans: {
      '.aims': {
        display: ['flex'],
        'flex-direction': ['column-reverse'],
        'justify-content': ['space-between'],
      },
      '.aims-light': {
        display: ['flex'],
        'justify-content': ['space-between'],
      },
      '.aims-dark': {
        display: ['flex'],
        'flex-wrap': ['wrap-reverse'],
      },
    },
  },
];
